import { useState } from "react";
import { getStoredValue, useLocalStorage } from "./useLocalStorage";
export const DEFAULT_DETAIL_KEY = "default";
var ValueType;
(function (ValueType) {
    ValueType["Ordering"] = "ordering";
    ValueType["Filters"] = "filters";
    ValueType["Columns"] = "columns";
})(ValueType || (ValueType = {}));
export function useArticleTableConfig(key) {
    const storeKey = `ArticleTableConfig::${key}`;
    const [storedConfig, setStoredValues] = useLocalStorage(storeKey);
    const [config, setConfig] = useState(storedConfig);
    const configDoesNotExist = (updatableConfig, configKey) => updatableConfig.filter(element => element.details?.key === configKey)
        .length === 0;
    const setValues = (configKey, values, typeOf) => {
        let updatableConfig = storedConfig ?? [];
        if (updatableConfig.length > 0) {
            updatableConfig?.forEach((element, index) => {
                if (element.details?.key === configKey) {
                    updatableConfig[index] = {
                        ...element,
                        [typeOf]: values,
                    };
                }
            });
            if (configDoesNotExist(updatableConfig, configKey)) {
                pushInitialSetup(updatableConfig, configKey, typeOf, values);
            }
        }
        else {
            pushInitialSetup(updatableConfig, configKey ?? DEFAULT_DETAIL_KEY, typeOf, values);
        }
        setStoredValues(updatableConfig);
    };
    const setFilters = (filters, configKey) => setValues(configKey ?? DEFAULT_DETAIL_KEY, filters, ValueType.Filters);
    const setOrdering = (ordering, configKey) => setValues(configKey ?? DEFAULT_DETAIL_KEY, ordering, ValueType.Ordering);
    const setColumns = (columns, configKey) => setValues(configKey ?? DEFAULT_DETAIL_KEY, columns, ValueType.Columns);
    const setDetails = (details) => setStoredValues([{ ...storedConfig, details }]);
    const getConfig = (configKey) => storedConfig.length > 0
        ? storedConfig.filter(element => element.details?.key === configKey)[0]
        : undefined;
    const refetch = () => {
        const item = getStoredValue(storeKey, storedConfig);
        setConfig(item);
    };
    return {
        config,
        getConfig,
        setFilters,
        setOrdering,
        setColumns,
        refetch,
        setDetails,
    };
}
const pushInitialSetup = (updatableConfig, key, typeOf, values) => updatableConfig.push({
    details: {
        key,
    },
    [typeOf]: values ?? undefined,
});
export const filterByDetail = (config, configKey) => config.filter(element => element.details?.key === (configKey ?? DEFAULT_DETAIL_KEY))[0];
